export async function hashWithSHA256(input: string) {
	const encodedData = new TextEncoder().encode(input);
	const buffer = await window.crypto.subtle.digest('SHA-256', encodedData);
	return Array.from(new Uint8Array(buffer)).map(b => b.toString(16).padStart(2, '0')).join('');
};